import { Input } from 'ui/input';
import type { InputBaseProps, InputNameProps } from 'ui/input';

import { useFormattedNumberInput } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-manager/goal/goal-form/hooks/use-formatted-number-input';

export type GoalValueInputProps = Omit<
  InputBaseProps,
  'value' | 'defaultValue' | 'onChange' | 'onBlur'
> &
  InputNameProps & {
    value?: number | string;
    onChange?: (value: number | string) => void;
    withSuffix?: boolean;
  };

const GoalValueInput = ({
  value,
  onChange = () => {},
  withSuffix = true,
  ...props
}: GoalValueInputProps) => {
  const { displayValue, handleChange, handleBlur } = useFormattedNumberInput({
    value,
    onChange,
    withSuffix,
    hasError: !!props.error || !!props.errorMessage,
  });

  return (
    <Input
      {...props}
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default GoalValueInput;
